module.exports = __webpack_public_path__ + "img/ionic.05a8a7f6.png";